module.exports = __webpack_public_path__ + "img/upload-motor-exotics.a843511e.jpg";